import styled from "styled-components";

export const DefaultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space["space-4"]};
`;

export const BottomSpacer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
